import { motion } from "framer-motion";

// Animates heading text word-by-word with clip mask
const WordReveal = ({ text, className = "", delay = 0, as = "h1", testId }) => {
  const Tag = motion[as] || motion.h1;
  const words = text.split(" ");
  return (
    <Tag className={className} data-testid={testId} initial="hidden" animate="show">
      {words.map((w, i) => (
        <span
          key={i}
          className="inline-block overflow-hidden align-bottom"
          style={{ paddingRight: "0.25em" }}
        >
          <motion.span
            className="inline-block"
            variants={{
              hidden: { y: "100%", opacity: 0 },
              show: (custom) => ({
                y: 0,
                opacity: 1,
                transition: {
                  duration: 0.9,
                  delay: delay + custom * 0.12,
                  ease: [0.16, 1, 0.3, 1],
                },
              }),
            }}
            custom={i}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export default WordReveal;
